// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"284":"ba1712fc","893":"7bf94aed"}[chunkId] || chunkId) + "." + {"284":"22db8dc83496e7a7","493":"3b01b5ebc1159612","567":"8d27e78fbeceaa75","893":"a1778d43026bc957"}[chunkId] + ".js";
};